import { render } from "./Editor.vue?vue&type=template&id=04532fe7&ts=true"
import script from "./Editor.vue?vue&type=script&lang=tsx"
export * from "./Editor.vue?vue&type=script&lang=tsx"

import "./Editor.vue?vue&type=style&index=0&id=04532fe7&lang=scss"

import exportComponent from "/home/jenkins/agent/workspace/git_node_build_images_push_anjinq_test/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__